import { render } from "./invoices-list.vue?vue&type=template&id=48f698b3&scoped=true"
import script from "./invoices-list.vue?vue&type=script&lang=js"
export * from "./invoices-list.vue?vue&type=script&lang=js"

import "./invoices-list.vue?vue&type=style&index=0&id=48f698b3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f698b3"]])

export default __exports__